import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import './DataDisplay.css';

const defaultArray = [];

// A read-only list of records, each a title line with optional meta on the right, an optional
// muted description and optional content below, separated by a rule. The caller builds every
// part, so the list knows nothing about what it shows.
export function DataDisplayList(
    {
        id = null,
        items = defaultArray,
        loading = false,
        className = ""
    }
) {
    return (
        <ul id={id} className={classNames("data-display-list bp6-list-unstyled", className)}>
            {items.map((item) => (
                <li key={item.key} className="data-display-list-item">
                    <div className={classNames("data-display-list-heading", { "bp6-skeleton": loading })}>
                        <div className="data-display-list-title">{item.title}</div>
                        <ShowHide
                            evaluator={item.meta != null}
                            show={(
                                <div className="data-display-list-meta bp6-text-muted">{item.meta}</div>
                            )}
                        />
                    </div>
                    <ShowHide
                        evaluator={item.description != null}
                        show={(
                            <div className={classNames("data-display-list-description bp6-text-muted", { "bp6-skeleton": loading })}>{item.description}</div>
                        )}
                    />
                    <ShowHide
                        evaluator={item.content != null}
                        show={(
                            <div className={classNames("data-display-list-content", { "bp6-skeleton": loading })}>{item.content}</div>
                        )}
                    />
                </li>
            ))}
        </ul>
    );
}

DataDisplayList.propTypes = {
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.node.isRequired,
        meta: PropTypes.node,
        description: PropTypes.node,
        content: PropTypes.node
    })),
    loading: PropTypes.bool,
    className: PropTypes.string
};
